/** @jsx h */
import { Component, h } from 'preact';
export function removeOrphans() {
  let content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return content.replace('\n', '').replace(/\s(((?!&shy;|&#173;|­)[^\s])*)$/, '&nbsp;$1').replace(/(&shy;|&#173;|­)([^\s]*)$/, '$2');
}
export default class HtmlContent extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.content !== this.props.content;
  }

  render() {
    const _this$props = this.props,
          content = _this$props.content,
          className = _this$props.className,
          dataKey = _this$props.dataKey,
          _this$props$preventOr = _this$props.preventOrphans,
          preventOrphans = _this$props$preventOr === void 0 ? true : _this$props$preventOr;
    const html = preventOrphans ? removeOrphans(content) : content;

    switch (this.props.type) {
      case 'p':
        return h("p", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: html
          },
          "data-key": dataKey
        });

      case 'div':
        return h("div", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: html
          },
          "data-key": dataKey
        });

      default:
        return h("span", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: html
          },
          "data-key": dataKey
        });
    }
  }

}